import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { formatDateTH_full2, formatDateTH } from "./DateUtil"; //formatDateTH_full

pdfMake.vfs = pdfFonts.pdfMake.vfs;
pdfMake.fonts = {
    THSarabunNew: {
        normal: "THSarabun.ttf",
        bold: "THSarabun Bold.ttf",
        italics: "THSarabun Italic.ttf",
        bolditalics: "THSarabun Bold Italic.ttf",
    },
    Roboto: {
        normal: "Roboto-Regular.ttf",
        bold: "Roboto-Medium.ttf",
        italics: "Roboto-Italic.ttf",
        bolditalics: "Roboto-MediumItalic.ttf",
    },
};

export const generateHead_RPT03 = (searchData) => {
    const styleFont = { alignment: "center", fontSize: 12 };

    const header = [
        {
            c1: "เลขรับที่",
            c2: "รับ วันเดือนปี",
            c3: "รับจากพนักงานสอบสวนแห่งใด",
            c4: "ชื่อผู้เสียหาย",
            c5: "ชื่อผู้ต้องหา",
            c6: "ข้อหา",
            c7: "พนักงานอัยการได้จัดการอย่างไร",
            c8: "พนักงานอัยการได้จัดการอย่างไร",
            c9: "ความเห็นผู้รับเสนอ",
            c10: "เลขหมายประเภทคดี",
            c11: "ชื่อผู้ตรวจสอบสำนวน",
            c12: "ทำลายสำนวนพ.ศ.",
            c13: "หนังสือแจ้ง",
            c14: "จัดเก็บ",
            c15: "หมายเหตุ",
        },
        { c1: "", c2: "", c3: "", c4: "", c5: "", c6: "", c7: "วัน เดือน ปี", c8: "ผลที่ได้จัดการไป", c9: "", c10: "", c11: "", c12: "", c13: "", c14: "", c15: "" },
    ];

    let resultobj = [];
    header.forEach((prop, index) => {
        let result = [];
        if (index === 0) {
            result = [
                { text: prop.c1, style: styleFont, rowSpan: 2 },
                { text: prop.c2, style: styleFont, rowSpan: 2 },
                { text: prop.c3, style: styleFont, rowSpan: 2 },
                { text: prop.c4, style: styleFont, rowSpan: 2 },
                { text: prop.c5, style: styleFont, rowSpan: 2 },
                { text: prop.c6, style: styleFont, rowSpan: 2 },
                { text: prop.c7, style: styleFont, colSpan: 2 },
                { text: prop.c8, style: styleFont },
                { text: prop.c9, style: styleFont, rowSpan: 2 },
                { text: prop.c10, style: styleFont, rowSpan: 2 },
                { text: prop.c11, style: styleFont, rowSpan: 2 },
                { text: prop.c12, style: styleFont, rowSpan: 2 },
                { text: prop.c13, style: styleFont, rowSpan: 2 },
                { text: prop.c14, style: styleFont, rowSpan: 2 },
                { text: prop.c15, style: styleFont, rowSpan: 2 },
            ];
        } else {
            result = Object.keys(prop).map((d, i) => ({ text: prop[d], style: styleFont }));
        }
        resultobj.push(result);
    });

    return [
        {
            text: "ส.1 สารบบรับความอาญา ปรากฎผู้ต้องหาที่ส่งตัวมา",
            style: { alignment: "center", fontSize: 14, bold: true },
        },
        {
            text: "สำนักงานอัยการจังหวัดสุรินทร์",
            style: { alignment: "center", fontSize: 14, bold: true },
        },
        {
            text: formatDateTH_full2(new Date(), false) + " ถึง " + formatDateTH_full2(new Date(), false),
            style: { alignment: "center", fontSize: 14, bold: true },
        },
        {
            columns: [
                {
                    table: {
                        widths: ["6.6%", "6.6%", "7.8%", "6.6%", "6.6%", "6.6%", "7%", "8%", "6.6%", "6.6%", "6.6%", "6.6%", "6.6%", "6.6%", "8.2%"],
                        body: resultobj,
                    },
                    layout: {
                        fillColor: function (rowIndex, node, columnIndex) {
                            return rowIndex < 3 ? "#CCCCCC" : null;
                        },
                        hLineWidth: function (i, node) {
                            return 0.25;
                        },
                        vLineWidth: function (i, node) {
                            return 0.25;
                        },
                    },
                },
            ],
        },
    ];
};
const INITIAL_PDF_MAKER = (head) => {
    return {
        defaultStyle: {
            font: "THSarabunNew",
            // alignment: "justify",
        },

        footer: (currentPage, pageCount) => {
            return [
                {
                    columns: [
                        // {
                        //     text: "",
                        //     alignment: "right",
                        //     margin: [0, 0, 0, 0]
                        // },
                        {
                            text: "พิมพ์เมื่อ " + formatDateTH(new Date(), true),
                            // alignment: "center",
                            alignment: "left",
                            margin: [40, 0, 0, 0],
                            // style: 'subheader',
                            fontSize: 14,
                        },
                        {
                            text: "หน้า " + currentPage.toString() + "/" + pageCount,
                            // alignment: "center",
                            alignment: "right",
                            margin: [50, 0, 50, 0],
                            // style: 'subheader',
                            fontSize: 14,
                        },
                    ],
                },
            ];
        },

        content: [{}],
    };
};

export const styles = {
    header: {
        fontSize: 20,
        bold: true,
    },
    subheader: {
        fontSize: 18,
        bold: true,
    },
    text: {
        fontSize: 16,
        bold: true,
    },
    quote: {
        italics: true,
    },
    small: {
        fontSize: 8,
    },
};

export const generatePdf = (head, content, callback) => {
    let config_header = INITIAL_PDF_MAKER(head);
    let object = {
        ...config_header,
        ...content,
    };
    const obj = pdfMake.createPdf(object);
    obj.getDataUrl((data) => callback(data));
    obj.open();
};
